import helpers from './helpers';
import Toash from './toash';
function toTop() {
    if (toTopEl) {
        toTopEl.addEventListener('click', function(e) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
}

function headerSticky() {
    if (headerEl) {
        let top = 130;
        if (window.innerWidth < 1200) {
            top = 90;
        }
        if (window.pageYOffset >= top) {
            headerEl.classList.add('sticky');
        } else {
            headerEl.classList.remove('sticky');
        }
    }
}

function nav() {
    let navEl = document.getElementById('jsNav'),
        navBtnEl = document.getElementById('jsNavBtn'),
        navBtnCloseEl = document.getElementById('jsNavBtnClose');
    if (navBtnEl) {
        navBtnEl.addEventListener('click', function() {
            if (navEl.classList.contains('show')) {
                navEl.classList.remove('show');
            } else {
                navEl.classList.add('show');
            }
        });
    }
    if (navBtnCloseEl) {
        navBtnCloseEl.addEventListener('click', function() {
            navEl.classList.remove('show');
        });
    }
}

function expandParent(className) {
    let expandEls = document.querySelectorAll(className);
    if (expandEls.length > 0) {
        expandEls.forEach(expandEl => {
            expandEl.addEventListener('click', function(event) {
                if (expandEl.parentElement.classList.contains('expand')) {
                    expandEl.parentElement.classList.remove('expand');
                } else {
                    expandEl.parentElement.classList.add('expand');
                }
                event.preventDefault();
            });
        });
    }
}

function showSpslide() {
    let splideEls = document.querySelectorAll('.splide');
    if (splideEls.length > 0) {
        splideEls.forEach(splideEl => {
            splideEl.classList.add('show');
        });
    }
}

function browseFile() {
    let browseFileEl = document.getElementById('jsBrowseFile')
    if (browseFileEl) {
        browseFileEl.addEventListener('change', function() {
            browseFileEl.previousElementSibling.value = this.value.replace(/C:\\fakepath\\/i, '');
        });
    }
}

function particles() {
    let particlesEl = document.getElementById('jsParticles');
    if (particlesEl) {
        particlesJS.load('jsParticles', '/assets/lib/particles/particles.json?v=202212311720', function() {});
    }
}

function copyLink() {
    let copyLinkEls = document.querySelectorAll('.jsCopyLink');
    if (helpers.arrIsNull(copyLinkEls)) {
        copyLinkEls.forEach(copyLinkEl => {
            copyLinkEl.addEventListener('click', function(e) {
                navigator.clipboard.writeText(copyLinkEl.href);
                toashEl.show('Đã copy link');
                e.preventDefault();
            });
        });
    }
}

let toTopEl = document.getElementById('jsToTop'),
    scrollEl = document.getElementById('jsScroll'),
    headerEl = document.getElementById('jsHeader'),
    timerResize,
    toashEl,
    timerScroll;
window.addEventListener('load', function() {
    //addLiveLoad();
    toashEl = new Toash('jsToash');
    showSpslide();
    toTopEl = document.getElementById('jsToTop'),
        scrollEl = document.getElementById('jsScroll'),
        headerEl = document.getElementById('jsHeader');
    toTop();
    helpers.showWhenScroll(toTopEl, 100);
    headerSticky();
    nav();
    expandParent('.jsExpand');
    browseFile();
    particles();
    copyLink();
    let popupCloseEls = document.querySelectorAll('.jsPopupClose'),
    popupEls = document.querySelectorAll('.jsPopup');
    if(popupCloseEls.length > 0) {
        popupCloseEls.forEach(popupCloseEl => {
            popupCloseEl.addEventListener('click', function() {
                popupCloseEl.closest('.jsPopup').classList.remove('show');
            });
        });
    }
    if(popupEls.length > 0) {
        popupEls.forEach(popupEl => {
            popupEl.addEventListener('click', function(e) {
                if (e.target.classList.contains('show')) {
                    popupEl.classList.remove('show');
                }
            });
        });
    }
});

function timeoutResize() {}
window.addEventListener('resize', function() {
    clearTimeout(timerResize);
    timerResize = setTimeout(timeoutResize, 300);
});

function timeoutScroll() {
    helpers.showWhenScroll(scrollEl, 100);
    helpers.showWhenScroll(toTopEl, 100);
}
window.addEventListener('scroll', function() {
    clearTimeout(timerScroll);
    timerScroll = setTimeout(timeoutScroll, 100);
    headerSticky();
});